module.exports = __webpack_public_path__ + "static/media/videos-icon-white.9fe83ed2.svg";